/* Import Section - Start */
/* React Imports - Start */
import React, { useState, useEffect, forwardRef, useRef } from "react";
/* React Imports - End */

/* Plugin Imports - Start */
import { InputText } from "primereact/inputtext";
import { useIsEdited } from "../../Providers/IsEditedProvider";
/* Plugin Imports - End */
/* Import Section - End */

/* Function - Start */
const InputTextElementElement = forwardRef((props, ref) => {
  /* State Declaration - Start */
  /* useState - Start */
  const [inputValue, setInputValue] = useState("");
  const { setIsEdited } = useIsEdited();
  /* useState - End */
  const debounceTimeoutRef = useRef(null); // Ref for debounce timeout
  /* State Declaration - End */

  /* Sync prop value with local state */
  useEffect(() => {
    if (props?.value && props.value !== inputValue ){
      setInputValue(props.value ? props.value : "");
    } else {
      if (props?.defaultValue && props.defaultValue !== inputValue) {
        setInputValue(props.defaultValue ? props.defaultValue : "");
      }
    }
  }, [props?.value, props?.defaultValue]);

  /* Methods - Start */
  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue); // Update local state immediately

    // Clear existing debounce timeout
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    // Set a new debounce timeout
    debounceTimeoutRef.current = setTimeout(() => {
      if (props.onChange) {
        setIsEdited(true);
        props.onChange(e); // Call parent-provided onChange
      }
    }, props.debounceTimeout || 500);
  };
  /* Methods - End */

  /* Render View Return - Start */
  return (
    <InputText
      id={props.id}
      name={props.name}
      value={inputValue}
      onChange={handleChange} // Debounced handler
      placeholder={props.placeholder}
      className={props.className}
      key={props.key}
      type={props.type}
      keyfilter={props.keyfilter}
      disabled={props.disabled}
      defaultValue={props.defaultValue}
      register={props.register}
      pattern={props.pattern}
      ref={ref}
      readOnly={props.readOnly}
      inputMode={props.inputMode}
    />
  );
  /* Render View Return - End */
});
/* Function - End */

/* Export default functionName; */
export default InputTextElementElement;